import { InternalAxiosRequestConfig } from 'axios';

type TokenGetter = () => Promise<string | null>;

let getToken: TokenGetter = async () => null;

export function setTokenGetter(getter: TokenGetter): void {
  getToken = getter;
}

// For callers that need the raw token outside axios (e.g. WebSocket URLs,
// where browsers cannot set an Authorization header).
export function getAuthToken(): Promise<string | null> {
  return getToken();
}

export async function authRequestInterceptor(
  config: InternalAxiosRequestConfig,
): Promise<InternalAxiosRequestConfig> {
  const token = await getToken();
  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  return config;
}
